import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeFrExtra from '@angular/common/locales/extra/fr';
import localeIt from '@angular/common/locales/it';
import localeItExtra from '@angular/common/locales/extra/it';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import localeNl from '@angular/common/locales/nl';
import localeNlExtra from '@angular/common/locales/extra/nl';
import localeEs from '@angular/common/locales/es';
import localeEsExtra from '@angular/common/locales/extra/es';
import localePl from '@angular/common/locales/pl';
import localePlExtra from '@angular/common/locales/extra/pl';
import localeRu from '@angular/common/locales/ru';
import localeRuExtra from '@angular/common/locales/extra/ru';
import localeSk from '@angular/common/locales/sk';
import localeSkExtra from '@angular/common/locales/extra/sk';
import localeHu from '@angular/common/locales/hu';
import localeHuExtra from '@angular/common/locales/extra/hu';
import localePt from '@angular/common/locales/pt';
import localePtExtra from '@angular/common/locales/extra/pt';

// PrimeNG
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MenuModule } from 'primeng/menu';
import { PasswordModule } from 'primeng/password';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { RippleModule } from 'primeng/ripple';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AddGatewayDialogComponent } from './components/add-gateway-dialog/add-gateway-dialog.component';
import { CommonCustomConfirmDialogComponent } from './components/common-custom-confirm-dialog/common-custom-confirm.dialog.component';
import { BusCalculationFooterComponent } from './components/busCalculation-footer/buscalculation.footer.component';
import { ClouseAccountComponent } from './components/close-account/close-account.component';
import { CommonFooterComponent } from './components/common-footer/common.footer.component';
import { CommonTopBarComponent } from './components/common-topbar/common.topbar.component';
import { VctAbandonPlantDialogComponent } from './components/vct-abandon-plant-dialog/vct-abandon-plant.dialog.component';
import { DeviceIconStandaloneComponent } from './components/device-icon-standalone/device-icon-standalone.component';
import { FilesDialogComponent } from './components/files-dialog/files.dialog.component';
import { InvitationsDialogComponent } from './components/invitations-dialog/invitations-dialog.component';
import { LanguageDialogModule } from './components/language/language.dialog.module';
import { NotificationsDeviceListComponent } from './components/notifications-device-list/notifications-device-list.component';
import { NotificationsDeviceManeuversComponent } from './components/notifications-device-maneuvers/notifications-device-maneuvers.component';
import { NotificationsModule } from './components/notifications/notifications.module';
import { PrivacyNoteDialogComponent } from './components/privacy-note-dialog/privacy-note.dialog.component';
import { ProfileComponent } from './components/profile/profile.component';
import { RatingDialogComponent } from './components/rating-dialog/rating-dialog.component';
import { ReleaseNoteDeviceDialogComponent } from './components/release-note-device-dialog/release-note-device.dialog.component';
import { ReleaseNoteDialogComponent } from './components/release-note-dialog/release-note.dialog.component';
import { SiteCardDesktopMobileComponent } from './components/site-card/site-card-desktop-tablet.component';
import { SiteCardMobileComponent } from './components/site-card/site-card-mobile.component';
import { SiteSelectorComponent } from './components/site-selector/site-selector.component';
import { SiteSelectorDialogComponent } from './components/site-selector-dialog/site-selector.dialog.component';
import { SlimTopBarComponent } from './components/slim-topbar/slim.topbar.component';
import { ThFinalUsersComponent } from './components/th-final-users/th-final-users.component';

import { FirstLetterPipe } from './pipes/first-letter.pipe';
import { LocalizedDatePipe } from './pipes/locale-date.pipe';
import { TruncatePipe } from './pipes/truncate';


registerLocaleData(localeFr, 'fr-FR', localeFrExtra);
registerLocaleData(localeIt, 'it-IT', localeItExtra);
registerLocaleData(localeDe, 'de-DE', localeDeExtra);
registerLocaleData(localeNl, 'nl-NL', localeNlExtra);
registerLocaleData(localeRu, 'ru-RU', localeRuExtra);
registerLocaleData(localeEs, 'es-ES', localeEsExtra);
registerLocaleData(localePl, 'pl-PL', localePlExtra);
registerLocaleData(localeSk, 'sk-SK', localeSkExtra);
registerLocaleData(localeHu, 'hu-HU', localeHuExtra);
registerLocaleData(localePt, 'pt-PT', localePtExtra);


@NgModule({
	declarations: [
		// Pipe
		FirstLetterPipe,
		LocalizedDatePipe,
		TruncatePipe,
		// Components
		AddGatewayDialogComponent,
		BusCalculationFooterComponent,
		ClouseAccountComponent,
		CommonFooterComponent,
		CommonTopBarComponent,
		DeviceIconStandaloneComponent,
		CommonCustomConfirmDialogComponent,
		FilesDialogComponent,
		InvitationsDialogComponent,
		NotificationsDeviceListComponent,
		NotificationsDeviceManeuversComponent,
		PrivacyNoteDialogComponent,
		ProfileComponent,
		RatingDialogComponent,
		ReleaseNoteDeviceDialogComponent,
		ReleaseNoteDialogComponent,
		SiteCardDesktopMobileComponent,
		SiteCardMobileComponent,
		SiteSelectorComponent,
		SiteSelectorDialogComponent,
		SlimTopBarComponent,
		ThFinalUsersComponent,
		VctAbandonPlantDialogComponent,
	],
	imports: [
		AccordionModule,
		AutoCompleteModule,
		BadgeModule,
		ButtonModule,
		CalendarModule,
		CardModule,
		CheckboxModule,
		CommonModule,
		ConfirmDialogModule,
		DividerModule,
		DropdownModule,
		FileUploadModule,
		FormsModule,
		InputNumberModule,
		InputTextModule,
		InputTextareaModule,
		LanguageDialogModule,
		MenuModule,
		NotificationsModule,
		PasswordModule,
		ProgressSpinnerModule,
		RadioButtonModule,
		RatingModule,
		ReactiveFormsModule,
		RippleModule,
		TableModule,
		TagModule,
		ToggleButtonModule,
		TooltipModule,
		TranslateModule,
		TreeModule
	],
	exports: [
		// Pipe
		FirstLetterPipe,
		LocalizedDatePipe,
		TruncatePipe,
		// Module
		ConfirmDialogModule,
		TranslateModule,
		// Components
		BusCalculationFooterComponent,
		CommonCustomConfirmDialogComponent,
		CommonFooterComponent,
		CommonTopBarComponent,
		DeviceIconStandaloneComponent,
		FilesDialogComponent,
		NotificationsDeviceListComponent,
		NotificationsDeviceManeuversComponent,
		PrivacyNoteDialogComponent,
		RatingDialogComponent,
		ReleaseNoteDeviceDialogComponent,
		ReleaseNoteDialogComponent,
		SiteSelectorComponent,
		SiteSelectorDialogComponent,
		SiteCardDesktopMobileComponent,
		SiteCardMobileComponent,
		SlimTopBarComponent,
		InvitationsDialogComponent,
	]
})
export class SharedModule { }
